import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeCtaSkeleton } from './TypeCta';
import type { TypeValueTextSkeleton } from './TypeValueText';

export interface TypeBlockValuePromptFields {
    internalName: EntryFieldTypes.Symbol;
    title?: EntryFieldTypes.Symbol;
    displayOption?: EntryFieldTypes.Symbol<'compact' | 'illustrative'>;
    colorOption?: EntryFieldTypes.Symbol<
        'color-light-beige' | 'color-light-grey' | 'color-light-purple' | 'color-no-background'
    >;
    values?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeValueTextSkeleton>>;
    cta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
}

export type TypeBlockValuePromptSkeleton = EntrySkeletonType<TypeBlockValuePromptFields, 'blockValuePrompt'>;
export type TypeBlockValuePrompt<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockValuePromptSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockValuePrompt<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockValuePrompt<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockValuePrompt';
}
